import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {TikTokCommentTiktokTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/commentTiktok';
import {useTranslation} from 'react-i18next';

const TikTokCommentTiktokTriggerActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<TikTokCommentTiktokTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-tiktok', {
    keyPrefix: 'triggers.comment-tiktok',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} />;
};

export default TikTokCommentTiktokTriggerActionCtaComponentPreview;
